/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0): modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */

if ($(".location-map").length > 0) {

    $.getScript("//cdn.rawgit.com/googlemaps/js-marker-clusterer/gh-pages/src/markerclusterer.js", function () {

    });
}

$(document).ready(function () {
    if ($(".map").length > 0) {
        var geocoder = new google.maps.Geocoder();
        var latitude = $("#map").data("lat");
        var longitude = $("#map").data("long");
        var title = "Embrace Home Loans";

        var latlng = new google.maps.LatLng(latitude, longitude);

        var settings = {
            zoom: 17,
            center: latlng,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            mapTypeControlOptions: { style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR },
            navigationControlOptions: { style: google.maps.NavigationControlStyle.SMALL }
        };

        var map = new google.maps.Map(document.getElementById("map"), settings);
        google.maps.event.addDomListener(window, "resize", function () {
            var center = map.getCenter();
            google.maps.event.trigger(map, "resize");
            map.setCenter(center);
        });

        google.maps.event.addListenerOnce(map, 'idle', function () {
            $("#map div.gm-style div:first-child")
                .attr("aria-label", "Map area, you can navigate here using the keyboard");
        });

        var contentString = '';
        var infowindow = new google.maps.InfoWindow({
            content: contentString
        });

        var companyPos = new google.maps.LatLng(latitude, longitude);

        var companyMarker = new google.maps.Marker({
            position: companyPos,
            map: map,
            title: title,
            zIndex: 3
        });
        // Custom label class
        class CustomLabel extends google.maps.OverlayView {
            constructor(position, text) {
                super();
                this.position = position;
                this.text = text;
            }

            onAdd() {
                const div = document.createElement("div");
                div.style.cssText = `
            position: absolute;
            background: white;
            padding: 4px 8px;
            border-radius: 3px;
            font-weight: bold;
            font-size: 14px;
            color: #000000;
            box-shadow: 0 2px 4px rgba(0,0,0,0.2);
            white-space: nowrap;`;
                div.textContent = this.text;
                this.div = div;
                const panes = this.getPanes();
                panes.overlayLayer.appendChild(div);
            }

            draw() {
                const overlayProjection = this.getProjection();
                const position = overlayProjection.fromLatLngToDivPixel(this.position);

                // ADJUST THESE VALUES to position the label:
                this.div.style.left = (position.x - 60) + "px";  // Move right from pin
                this.div.style.top = (position.y - 65) + "px";   // Move up from pin
            }

            onRemove() {
                if (this.div) {
                    this.div.parentNode.removeChild(this.div);
                    this.div = null;
                }
            }
        }

        // Create and add the label
        const label = new CustomLabel(
            new google.maps.LatLng(latitude, longitude),
            "Embrace Home Loans"
        );
        label.setMap(map);
        //const companyMarker = new markerwithlabel.MarkerWithLabel({
        //    position: { lat: latitude, lng: longitude },
        //    map: map,
        //    labelContent: "Embrace Home Loans",
        //    labelAnchor: new google.maps.Point(-30, 40), // Adjust these values
        //    labelClass: "map-label",
        //    labelStyle: {
        //        opacity: 1
        //    }
        //});
    }
    var gmarkers = [];
    var totalInfoWindow = [];
    //load data for locarions map
    if ($(".location-map").length > 0) {
        var LocB = $('#locations-longlat').val();
        var FAddress = $('#locations-addresses').val();
        var NameB = $('#locations-names').val();
        var Phone = $('#locations-phones').val();
        var LocationPage = $('#locations-urls').val();
        

        var map;
        var mc; //marker clusterer
        var mcOptions = { gridSize: 10, maxZoom: 8, imagePath: 'http://cdn.rawgit.com/googlemaps/js-marker-clusterer/gh-pages/images/m' };
        var geocoder = new google.maps.Geocoder(); //geocoder

        var Markers = [];
        LocB = LocB.split("@@");
        NameB = NameB.split("@@");
        Phone = Phone.split("@@");
        FAddress = FAddress.split("@@");
        LocationPage = LocationPage.split("@@");
       

        if ($(".ocean-first-map").length > 0) {
            var LoanOfficerNames = $('#lo-names').val();
            LoanOfficerNames = LoanOfficerNames.split("@@");
            for (var L = 0; L < NameB.length; L++) {

                var address = FAddress[L];

                var arr1 = [NameB[L], address, Phone[L], LocationPage[L], LoanOfficerNames[L]];

                Markers.push(arr1);
            }
        }
        else {
            for (var L = 0; L < NameB.length; L++) {

                var address = FAddress[L];

                var arr1 = [NameB[L], address, Phone[L], LocationPage[L]];

                Markers.push(arr1);
            }
        }


        var address = new Array();
        for (var i = 0; i < LocB.length; i++) {
            address.push(LocB[i]);
        }

        //min and max limits for multiplier, for random numbers //keep the range pretty small, so markers are kept close by
        var min = .999999;
        var max = 1.000001;

        function createMarker(latlng, text) {

            var infowindow = new google.maps.InfoWindow({
                content: text,
            });

            totalInfoWindow.push(infowindow)

            var marker = new google.maps.Marker({
                position: latlng,
                map: map
            });

            google.maps.event.addListener(marker, 'click', function () {
                infowindow.open(map, marker);
            });
            return marker;
        }

        function initialize() {
            var options = {
                zoom: 4,
                center: new google.maps.LatLng(39.0000, -80.5000),
                mapTypeId: google.maps.MapTypeId.ROADMAP
            };
            var learnmore = "Learn More";
            if ($(".ocean-first-map").length > 0) {
                learnmore = "View Loan Officer";
                options.zoom = 8;
                options.center = new google.maps.LatLng(40.060000, -74.900000);
            }


            map = new google.maps.Map(document.getElementById('locations-map'), options);
            google.maps.event.addDomListener(window, "resize", function () {
                var center = map.getCenter();
                google.maps.event.trigger(map, "resize");
                map.setCenter(center);
            });

            google.maps.event.addListenerOnce(map, 'idle', function () {
                $(".location-map div.gm-style div:first-child")
                    .attr("aria-label", "Map area, you can navigate here using the keyboard");
            });

            if ($(".ocean-first-map").length > 0) {
                for (i = 0; i < address.length; i++) {
                    var ptStr = address[i];
                    var coords = ptStr.split(",");

                    var content = "<div style='width:100%; height: 100%'>";
                    content += "<h3 class='m-0 color7'>" + Markers[i][0] + "</h3> <p>" + Markers[i][1] + "</p>";

                    if (Markers[i][2] != "")
                        content += "<p>Phone :<a href=tel:'" + Markers[i][2] + "'>" + Markers[i][2] + "</a></p>";

                    content += "<p><strong>" + Markers[i][4] + "</strong></p>";

                    content += "<p><a href='" + Markers[i][3] + "'><strong>" + learnmore + "</strong></a></p>";
                    content += "</div>";

                    var latlng = new google.maps.LatLng(parseFloat(coords[0]), parseFloat(coords[1]))
                    gmarkers.push(createMarker(latlng, content));

                }
            }
            else {
                for (i = 0; i < address.length; i++) {
                    var ptStr = address[i];
                    var coords = ptStr.split(",");

                    var content = "<div style='width:100%; height: 100%'>";
                    content += "<h3 class='m-0 color7'>" + Markers[i][0] + "</h3> <p>" + Markers[i][1] + "</p>";

                    if (Markers[i][2] != "")
                        content += "<p>Phone :<a href=tel:'" + Markers[i][2] + "'>" + Markers[i][2] + "</a></p>";

                    content += "<p><a href='" + Markers[i][3] + "'><strong>" + learnmore + "</strong></a></p>";
                    content += "</div>";

                    var latlng = new google.maps.LatLng(parseFloat(coords[0]), parseFloat(coords[1]))
                    gmarkers.push(createMarker(latlng, content));

                }
            }
          
            //marker cluster
            mc = new MarkerClusterer(map, gmarkers, mcOptions);
        }

        google.maps.event.addDomListener(window, 'load', initialize);
    }

    $(document).on("click", ".on-site-map", function (e) {
        var parent = e.currentTarget.parentElement;
        var lat = parent.dataset.lat;
        var lng = parent.dataset.lng;
        var center = new google.maps.LatLng(lat, lng);
        var zoom = 10;

        totalInfoWindow.filter(window => {
            window.close();
        });
        gmarkers.filter(marker => {
            if (marker.getPosition().lat() === center.lat() && marker.getPosition().lng() === center.lng()) {
                google.maps.event.trigger(marker, "click");
            }
        });

        map.setZoom(zoom);
        map.setCenter(center);
    });
});


$("area.licensing").click(function () {
    $("#stateName").html($(this).attr("state"));
    $("#licenseInfo").html($(this).attr("info"));
});

$("area.amplicensing").click(function () {

    $("#stateName").html($(this).attr("state"));

    var stateOperatedAMPLOsendpoint = stateOperatedAMPLOs_endpoint;

    var clickedData = {
        StateCode: $(this).attr("code")
    };
    $.ajax({
        url: stateOperatedAMPLOsendpoint,
        type: 'POST',
        dataType: 'json',
        data: JSON.stringify(clickedData),
        contentType: 'application/json; charset=utf-8',
        success: function (data) {
            if (data != null && data.length > 0) {
                var LOsData = "";
                for (var i = 0; i < data.length; i++) {
                    var LODate = "<div><p><a href='" + data[i].URL + "'>" + data[i].Name + "</a></p><p>" + data[i].Email + "</p><p>" + data[i].Cell + "</p><p>" + data[i].Landline + "</p></div>";
                    LOsData += LODate;
                    $("#licenseInfo").html(LOsData);
                }

            }
            else {
                $("#licenseInfo").html("No loan officers operating in this state");
            }
        },
        error: function (data) {

        }
    });

});


if ($(".licensing-map").length > 0) {
    $.getScript("https://cdnjs.cloudflare.com/ajax/libs/jQuery-rwdImageMaps/1.6/jquery.rwdImageMaps.min.js", function () {
        $('img[usemap]').rwdImageMaps();
    });
}

$(".map, .location-map").focusin(function () {
    document.getElementById("mapTips").classList.remove("d-none");
});

$(".map, .location-map").focusout(function () {
    document.getElementById("mapTips").classList.add("d-none");
});

//# sourceMappingURL=modal.js.map
